const PbxxRecord = require('../pbxx_record')

module.exports = class EligibilityCriteria extends PbxxRecord {
  static get class_name() {
    return 'EligibilityCriteria'
  }
}
